module.exports = __webpack_public_path__ + "img/海藻.2c5c579c.jpg";